// TODO: create a uikit component for accordion which handles these
import { useStyleConfigV2 } from '@tectonic/elemason-components';
import { Clickable } from '@tectonic/uikit';
import clsx from 'clsx';
import { useState, type FC } from 'react';
import { Cell } from '../../core/Cell';
import { useAccessorValue } from '../../hooks/useAccessorValue';

import type { ElemasonHorizontalAccordionWidget } from '@tectonic/types';

interface ElemasonHorizontalAccordionWidgetProps {
  widget: ElemasonHorizontalAccordionWidget;
}

const HorizontalAccordionWidget: FC<ElemasonHorizontalAccordionWidgetProps> = ({
  widget: { config, data },
}) => {
  const [activeIndex, setActiveIndex] = useState<number>();
  const collapsible = useAccessorValue(config?.collapsible ?? {});
  const [style, className] = useStyleConfigV2(config?.container ?? {});
  const [headerStyle, headerClassName] = useStyleConfigV2(config?.header ?? {});
  const [itemStyle, itemClassName] = useStyleConfigV2(config?.item ?? {});

  const onClick = (index: number) => {
    if (activeIndex === index && collapsible) {
      setActiveIndex(undefined);
      return;
    }
    setActiveIndex(index);
  };

  if (!data || !data.items) return null;

  return (
    <div style={style} className={className}>
      <div className={clsx('flex', headerClassName)} style={headerStyle}>
        {data.items.map((item, index) => (
          <Clickable
            key={index}
            style={itemStyle}
            className={clsx('flex', itemClassName)}
            onClick={() => onClick(index)}
          >
            {index === activeIndex ? (
              <Cell cell={item.trigger.open} />
            ) : (
              <Cell cell={item.trigger.close} />
            )}
          </Clickable>
        ))}
      </div>
      {activeIndex !== undefined && (
        <Cell cell={data.items[activeIndex]?.content} />
      )}
    </div>
  );
};

export { HorizontalAccordionWidget };
